import { Model } from 'flexlayout-react';
import { DocumentData } from '../../context/DocumentDataProvider';
import { findReactFlowTabset } from './FindReactFlowTabset';

// Función para agregar una nueva figura
export const handleAddTable = (setDocumentData: React.Dispatch<React.SetStateAction<DocumentData>>,
    setTable: React.Dispatch<React.SetStateAction<Map<string, any>>>,
    layoutModel: Model,
    setLayoutModel: React.Dispatch<React.SetStateAction<Model>>,
    uniqueId: string,
    tableName: string,
) => {
    // Actualizamos el state de `tables` de forma atómica y obtenemos el nombre/id nuevo
    let newTableName = '';
    setTable(prev => {
        const updated = new Map(prev);
        const newIndex = (prev?.size || 0) + 1;
        newTableName = tableName || `Table ${newIndex}`;

        // Datos básicos de ejemplo para la tabla
        const newTable = {
            id: uniqueId,
            // rows: array de objetos (filas)
            rows: [
                { Index: 1, Label: 'A', Value: 3.14 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
                { Index: 2, Label: 'B', Value: 2.71 },
                { Index: 3, Label: 'C', Value: 1.62 },
            ],
            // columnas opcionales (TableTab acepta columns o las infiere)
            columns: ['Index', 'Label', 'Value'],
        };

        updated.set(uniqueId, newTable);
        return updated;
    });

    // Añadimos la nueva pestaña al modelo de flexlayout
    setLayoutModel(prevModel => {
        const json = prevModel.toJson();
        const tabset = findReactFlowTabset(json.layout);
        if (tabset) {
            const newTab = {
                id: uniqueId,
                type: 'tab',
                name: newTableName,
                // Este nombre de componente debe coincidir con el que registra la app en el
                // factory del Layout. Aquí usamos 'TableTab' para indicar el componente
                // React que renderiza la tabla (`TableTab.tsx`).
                component: 'TableTab',
                config: {},
                enableClose: false,
                enableDrag: true,
                enableRename: true,
                children: [],
                icon: 'table.svg',
            };
            tabset.children.push(newTab);
        } else {
            console.warn('No tabset found in layout JSON to add the table tab.');
        }

        // Recreate model from JSON to apply changes (remonta children)
        return Model.fromJson(json);
    });
};